export function farloUiCastCarousel(element) {
    const siteCastUpper = element.querySelector('.site-cast__upper');
    const siteCastLower = element.querySelector('.site-cast__lower');


    flkty = new Flickity(siteCastUpper, {
        cellAlign: 'center',
        pageDots: true,
        prevNextButtons: false,
        scrollSnap: true,
        wrapAround: true,
        groupCells: true,
        freeScroll: false,
        draggable: false,
        fade: true
    });

    flkty = new Flickity(siteCastLower, {
        cellAlign: 'center',
        asNavFor: siteCastUpper,
        pageDots: false,
        prevNextButtons: false,
        scrollSnap: true,
        wrapAround: true,
        groupCells: true,
        freeScroll: false,
        draggable: false,
        fade: true
    });


}